/**密码登录 */
export class LoginVO {
  constructor() {
    this.username = "";
    this.password = "";
    this.verifyCode = "";
  }
}
